import { Page } from "app/services/models/page";

export class PageProject extends Page{
    filterDateStartFrom:string;
    filterDateStartTo: string;
    filterDateContractEnd: string;
    filterActive:boolean;
    filterUserId:string;
    filterCapId:string;
    filterProjId:string;
    ignoreCurrentUser:boolean;
    isActive:string;
    isPlanificable:string;
    isOcult:string;
    businessUnit:string;
}


// WEBPACK FOOTER //
// ./src/app/services/models/page-project.ts